// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("js/" + (chunkId === 7076 ? "actioncable" : chunkId) + "-" + {"7076":"0e14365e290495fccf4e","8072":"5f66c584783ecb3d60d7"}[chunkId] + ".chunk.js");